import React, { useEffect, useState } from "react";
import { houseKeepingData } from "../../../Universal/Hotels/Components/HouseKeepingAssignRoom/Components/HouseKeepingData";
import { useNavigate } from "react-router-dom";
import DataTableHeader from "../../../../Common/CommonHeader/CommonHeader";
import { toast } from "react-toastify";
import DataTableFooter from "../../../../Common/DataTableFooter/DataTableFooter";
import CommonLoading from "../../../../Common/CommonLoading";
import { useDispatch, useSelector } from "react-redux";
import { GET_ROOM_TYPE_REQUEST } from "../../../../Utils/Constant";
import { getBaseUrl } from "../../../../Redux/Config/AppConfig";
import ConfirmationATM from "../../../../Common/ConfirmationATM";
import { format } from "date-fns";
import { hasDeleteAccess } from "../../../../Common/CheckAccess";

const RoomListCards = ({
  selectedRoom,
  setSelectedRoom,
  refreshData,
  refreshKey,
}) => {
  const BaseUrl = getBaseUrl();
  const dispatch = useDispatch();
  const { roomList, loading, error } = useSelector((state) => state.roomType);

  const [data, setData] = useState([]);
  const [pageSize, setPageSize] = useState(12);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalEntries, setTotalEntries] = useState(0);
  const [globalFilter, setGlobalFilter] = useState("");
  const [gloablFilterType, setGloablFilterType] = useState("Room type");
  const [islistDataLoading, isSetListDataLoading] = useState(false);
  const [sortBy, setSortBy] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [roomToDelete, setRoomToDelete] = useState(null);

  const [permissions, setPermissions] = useState([]);

  const existingPermissions = localStorage.getItem("checkPermission");

  useEffect(() => {
    if (existingPermissions != undefined) {
      const parsedData = JSON.parse(existingPermissions);
      setPermissions(parsedData);
    }
  }, [existingPermissions]);

  const sortByOptions = ["Room type", "Room status", "Date Range"];
  useEffect(() => {
    dispatch({
      type: GET_ROOM_TYPE_REQUEST,
      payload: { page: currentPage, size: pageSize },
    });
  }, [dispatch, currentPage, pageSize]);

  useEffect(() => {
    setGlobalFilter("");
    setStartDate(null);
    setEndDate(null);
    setCurrentPage(1);
  }, [gloablFilterType]);

  const fetchData = async () => {
    isSetListDataLoading(true);
    const params = new URLSearchParams();

    params.set("page", currentPage);
    params.set("limit", pageSize);

    if (gloablFilterType === "Room type") {
      params.set("room_type", globalFilter);
    } else if (gloablFilterType === "Room status") {
      params.set("room_status", globalFilter);
    } else if (gloablFilterType === "Date Range") {
      if (startDate) params.set("start_date", startDate.toISOString());
      if (endDate) params.set("end_date", endDate.toISOString());
    }
    dispatch({
      type: "GET_ROOM_LIST_REQUEST",
      payload: params,
    });
    isSetListDataLoading(true);
  };

  useEffect(() => {
    if (roomList?.data?.data) {
      setData(roomList?.data?.data?.rooms);
      setTotalEntries(roomList?.data?.data?.pagination?.totalResults || 0);
    }
    isSetListDataLoading(false);
  }, [roomList]);

  useEffect(() => {
    fetchData();
  }, [
    refreshKey,
    pageSize,
    currentPage,
    globalFilter,
    startDate,
    endDate,
    sortBy,
    sortOrder,
  ]);

  const handleDeleteClick = (room, e) => {
    e.stopPropagation();
    setRoomToDelete(room);
    setShowDeleteModal(true);
  };

  const handleStatusUpdate = async (room, e) => {
    e.stopPropagation();
    try {
      const formData = {
        room_number: room.room_number,
        room_type: room.room_id,
        room_status: "available",
        floor_number: room.floor_number,
        standard_checkout: room.standard_checkout,
      };
      let token = localStorage.getItem("token");

      let hotel_id = localStorage.getItem("hotel_id");
      formData.hotel_id = hotel_id;
      const url = `${BaseUrl}/room/update-room-number/${room.id}`;
      const method = "PATCH";
      const response = await fetch(url, {
        method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error(`Status update failed: ${response.status}`);
      }

      // const result = await response.json();
      fetchData(); // Refresh the data
    } catch (error) {
      console.error("Error updating room status:", error);
      toast.error("Failed to update room status. Please try again.");
    }
  };

  const confirmDelete = async () => {
    if (!roomToDelete) return;

    try {
      let token = localStorage.getItem("token");

      const response = await fetch(
        `${BaseUrl}/room/delete-room-number/${roomToDelete.id}`,
        {
          method: "DELETE",
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (!response.ok) throw new Error("Failed to delete room");
      toast.success("Room Number deleted successfully");
      fetchData();
      if (refreshData) refreshData();
    } catch (err) {
      console.error("Delete error:", err);
    } finally {
      setShowDeleteModal(false);
      setRoomToDelete(null);
    }
  };

  const totalPages = Math.ceil(totalEntries / pageSize);

  return (
    <div className="col-sm-12">
      <div className="position-relative">
        <div className="card-body">
          <div className="row g-3">
            <div className="col-12 d-flex flex-wrap justify-content-end align-items-center gap-3">
              {gloablFilterType === "Date Range" ? (
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <label className="form-label mb-0">Select Date:</label>
                  <select
                    className="form-select"
                    style={{ width: "200px" }}
                    value={gloablFilterType}
                    onChange={(e) => setGloablFilterType(e.target.value)}
                  >
                    {sortByOptions.map((sort, index) => (
                      <option value={sort} key={index}>
                        {sort}
                      </option>
                    ))}
                  </select>
                </div>
              ) : (
                <div>
                  <select
                    className="form-select"
                    style={{ width: "200px" }}
                    value={gloablFilterType}
                    onChange={(e) => setGloablFilterType(e.target.value)}
                  >
                    {sortByOptions.map((sort, index) => (
                      <option value={sort} key={index}>
                        {sort}
                      </option>
                    ))}
                  </select>
                </div>
              )}

              {gloablFilterType === "Date Range" ? (
                <>
                  <div>
                    <label className="form-label mb-0">Select Date:</label>
                    <input
                      type="date"
                      className="form-control"
                      value={startDate ? format(startDate, "yyyy-MM-dd") : ""}
                      onChange={(e) =>
                        setStartDate(
                          e.target.value ? new Date(e.target.value) : null
                        )
                      }
                    />
                  </div>
                  {/* <div>
                    <label className="form-label mb-0">End Date:</label>
                    <input
                      type="date"
                      className="form-control"
                      value={endDate ? format(endDate, 'yyyy-MM-dd') : ''}
                      onChange={(e) =>
                        setEndDate(e.target.value ? new Date(e.target.value) : null)
                      }
                      min={startDate ? format(startDate, 'yyyy-MM-dd') : ''}
                    />
                  </div> */}
                </>
              ) : (
                <>
                  <label className="form-label mb-0">Search:</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder={`Enter room ${
                      gloablFilterType === "Room type" ? "type" : "status"
                    }`}
                    style={{ width: "200px" }}
                    value={globalFilter}
                    onChange={(e) => setGlobalFilter(e.target.value)}
                  />
                </>
              )}
            </div>

            {islistDataLoading ? (
              <div className="col-12 d-flex justify-content-center py-5">
                <CommonLoading />
              </div>
            ) : data?.length <= 0 ? (
              <div className="w-100 d-flex justify-content-center align-items-center fw-semibold mt-2">
                No data available
              </div>
            ) : (
              <>
                <div className="row g-3">
                  {data.map((room, index) => (
                    <div
                      className="col-12 col-sm-6 col-md-4 col-lg-3"
                      key={index}
                    >
                      <div
                        className="border shadow-sm p-3 rounded h-100 position-relative"
                        onClick={() => setSelectedRoom(room)}
                      >
                        {hasDeleteAccess(permissions, "rooms") && (
                          <div
                            className="position-absolute"
                            style={{ top: "10px", right: "10px" }}
                            onClick={(e) => handleDeleteClick(room, e)}
                          >
                            <img
                              src="/trash.png"
                              alt="Delete"
                              style={{
                                width: "20px",
                                height: "20px",
                                cursor: "pointer",
                              }}
                            />
                          </div>
                        )}
                        {room.room_status === "cleaning in progress" && (
                          <div
                            className="position-absolute"
                            style={{ top: "10px", right: "40px" }}
                            onClick={(e) => handleStatusUpdate(room, e)}
                          >
                            <button
                              className="btn btn-success btn-sm"
                              style={{ fontSize: "10px", padding: "2px 6px" }}
                              title="Mark as Available"
                            >
                              ✓
                            </button>
                          </div>
                        )}
                        <div className="text-center">
                          <span
                            className="fw-bold d-block text-primary fs-5 hover-underline"
                            style={{
                              cursor: "pointer",
                              textDecoration: "none",
                            }}
                            data-bs-toggle="offcanvas"
                            data-bs-target="#add-room"
                          >
                            {room?.room_number}
                          </span>
                          <div className="mt-1 text-capitalize fw-semibold">
                            {room.room_status}
                          </div>
                          <div className="mt-1 text-capitalize fw-semibold">
                            Floor No {room.floor_number}
                          </div>
                        </div>
                        <span
                          className="badge bg-secondary position-absolute"
                          style={{ bottom: "10px", right: "10px" }}
                        >
                          {room.room_type}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="col-12 text-end">
                  <DataTableFooter
                    currentPage={currentPage}
                    totalPages={totalPages}
                    setCurrentPage={setCurrentPage}
                    totalEntries={totalEntries}
                    pageSize={pageSize}
                  />
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      <ConfirmationATM
        show={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={confirmDelete}
        title="Delete Room"
        message={`Are you sure you want to delete room ${roomToDelete?.room_number}?`}
      />
    </div>
  );
};

export default RoomListCards;
